import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Tweens } from "../Components/Effects/Tweens";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { PlayList } from "../Components/Sounds/PlayList";
import { Payline } from "../GameComponents/Payline";
import { Paylines } from "../GameComponents/Paylines";
import { Symbol } from "../GameComponents/Symbol";
import { Symbols } from "../GameComponents/Symbols";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { BetManager } from "../Managers/BetManager";
import { AppContext } from "../../Common/AppContext";
import { MachineExtended } from "./MachineExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    //******************************************************************************************************************
    //  TIMER STATUSES
    //******************************************************************************************************************

    protected static readonly ShowFirstWinsStep1 = "showFirstWinsStep1";

    protected static readonly ShowFirstWinsStep2 = "showFirstWinsStep2";

    protected static readonly ShowFirstWinsStep3 = "showFirstWinsStep3";

    protected static readonly ShowFirstWinsStep4 = "showFirstWinsStep4";

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected counter: ImageTextCounterElement;

    protected currentCounterStep: number;

    //******************************************************************************************************************
    //  CREATE, INITIALIZE
    //******************************************************************************************************************

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
    ): void {
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);

        this.createCounter();
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
            for (let i: number = 0; i < reelsData[reelIndex].symbols.length; i++) {
                if (reelsData[reelIndex].symbols[i] === 9 && this.currentSymbols[reelIndex][i] != null) {
                    this.symbolsContainer.addChild(this.currentSymbols[reelIndex][i]);
                    if (reelIndex === 0) {
                        PlayList.play("SND_BaseWildHit01");
                    } else if (reelIndex === 1 && this.countWilds(reelIndex) === 1) {
                        PlayList.play("SND_BaseWildHit01");
                    } else if (reelIndex === 1 && this.countWilds(reelIndex) === 2) {
                        PlayList.play("SND_BaseWildHit02");
                    } else if (reelIndex === 2 && this.countWilds(reelIndex) === 1) {
                        PlayList.play("SND_BaseWildHit01");
                    } else if (reelIndex === 2 && this.countWilds(reelIndex) === 2) {
                        PlayList.play("SND_BaseWildHit02");
                    } else if (reelIndex === 2 && this.countWilds(reelIndex) === 3) {
                        PlayList.play("SND_BaseWildHit03");
                    }
                }
            }
        }

        if (this.countWilds(reelIndex) > 0 && !MachineExtended.Force) {
            if (reelIndex === 2 && this.countWilds(reelIndex) === 1 && this.currentReels[2].symbols.indexOf(9) !== -1) {
            } else {
                this.imapctWilds(reelIndex);
                this.teasNowinSymbols(reelIndex);
            }
        }
    }

    private teasNowinSymbols(reelIndex: number): void {
        for (let i: number = 0; i <= reelIndex; i++) {
            for (let j: number = 0; j < this.currentSymbols[reelIndex].length; j++) {
                if (this.currentSymbols[i][j].id !== 8) {
                    this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                }
            }
        }
    }

    private imapctWilds(reelIndex: number): void {
        for (let i: number = 0; i <= reelIndex; i++) {
            for (let j: number = 0; j < this.currentSymbols[reelIndex].length; j++) {
                if (this.currentSymbols[i][j].id === 8) {
                    this.currentSymbols[i][j].goToCase("IMPACT");
                }
            }
        }
    }

    protected countWilds(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            if (this.currentReels[i].symbols.indexOf(9) !== -1) {
                count++;
            }
        }

        return count;
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.resetCounter();

        return super.showWins(wins, win);
    }

    protected showFirstWins(): void {
        if (this.currentMultiplierIndex < 3) {
            this.currentCounterStep = 0;

            this.startTimer(WinAnimator2.ShowFirstWinsStep1, 15);
        } else {
            super.showFirstWins();
        }
    }

    protected showFirstWinsStep1(): void {
        const win = this.currentWins[this.currentCounterStep];

        this.allPaylinesGoToCase(Payline.CaseNowin);
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseNormal);
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
        }

        this.winPaylineGoToCase(this.currentCounterStep, Payline.CaseWin);
        this.winSymbolsGoToCase(this.currentCounterStep, Symbol.CaseQuickWin, false);

        this.runCounterStep1();

        this.currentCounterStep++;
        let time: number = 30;

        if (this.currentMultiplierIndex === 0) {
            time = 0;
        }

        this.startTimer(
            this.currentCounterStep < this.currentWins.length
                ? WinAnimator2.ShowFirstWinsStep1
                : WinAnimator2.ShowFirstWinsStep2,
            time,
        );
    }

    protected showFirstWinsStep2(): void {
        this.currentCounterStep = null;

        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseNormal);
            if (this.currentMultiplierIndex === 0) {
                this.winSymbolsGoToCase(i, Symbol.CaseQuickWin, false);
            } else {
                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            }
        }

        this.runCounterStep2();

        let time: number = 90;

        if (this.currentMultiplierIndex === 0) {
            time = 45;
        }

        this.startTimer(WinAnimator2.ShowFirstWinsStep3, time);

        this.emit(WinAnimator.FinishWinCalculation);
    }

    protected showFirstWinsStep3(): void {
        this.runCounterStep3();

        this.startTimer(WinAnimator2.ShowFirstWinsStep4, 40);
    }

    protected showFirstWinsStep4(): void {
        this.emit(WinAnimator.FinishWinAnimator);

        this.currentCycle = 0;

        this.cycleWins();
    }

    //******************************************************************************************************************
    //  SHOW INIT WINS
    //******************************************************************************************************************

    public showInitWins(wins: Array<Communication.Game.IWin>, win: number): void {
        this.resetCounter();

        super.showInitWins(wins, win);
    }

    //******************************************************************************************************************
    //  RESET
    //******************************************************************************************************************

    public reset(showLastSymbols: boolean, spin = false): boolean {
        switch (this.timerStatus) {
            case WinAnimator2.ShowFirstWinsStep1:
                this.runCounterOutro();
                break;
            case WinAnimator2.ShowFirstWinsStep2:
            case WinAnimator2.ShowFirstWinsStep3:
                this.runCounterStep3();
                break;
        }

        if (this.currentCounterStep != null) {
            this.currentCounterStep = null;

            this.runCounterOutro();
        }

        return super.reset(showLastSymbols, spin);
    }

    //******************************************************************************************************************
    //  TIMER
    //******************************************************************************************************************

    protected onTimerComplete(): void {
        this.timer.stop();

        switch (this.timerStatus) {
            case WinAnimator2.ShowFirstWinsStep1:
                this.showFirstWinsStep1();
                break;
            case WinAnimator2.ShowFirstWinsStep2:
                this.showFirstWinsStep2();
                break;
            case WinAnimator2.ShowFirstWinsStep3:
                this.showFirstWinsStep3();
                break;
            case WinAnimator2.ShowFirstWinsStep4:
                this.showFirstWinsStep4();
                break;
            default:
                super.onTimerComplete();
                break;
        }
    }

    //******************************************************************************************************************
    //  ANIMATIONS
    //******************************************************************************************************************

    protected getAnimationIndex(): number {
        return this.currentMultiplierIndex - 3;
    }

    //******************************************************************************************************************
    //  COUNTER
    //******************************************************************************************************************

    protected createCounter(): void {
        this.counter = this.childs["Counter"];

        this.animationsContainer.addChild(this.counter);
    }

    protected resetCounter(): void {
        this.timerStatus = "";
        Tweens.removeTweens(this.counter, "all");

        this.counter.alpha = 0;
    }

    protected runCounterStep1(): void {
        PlayList.play("SND_BasePayline" + (this.currentCounterStep + 1));

        let amountFrom = "0";
        let amountTo = "0";

        for (let i = 0; i <= this.currentCounterStep; i++) {
            const win = this.currentWins[i];

            if (win.type === Communication.Game.WinType.Cash) {
                if (i < this.currentCounterStep) {
                    amountFrom = NumberUtils.add(amountFrom, this.currentWins[i].amount);
                }

                amountTo = NumberUtils.add(amountTo, this.currentWins[i].amount);
            }
        }

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            this.counter.start(
                parseInt(NumberUtils.devide(amountFrom, BetManager.CoinSize).toString()),
                parseInt(NumberUtils.devide(amountTo, BetManager.CoinSize).toString()),
                0,
            );
        } else {
            ImageTextCounterElement.Round = false;
            this.counter.start(parseFloat(amountFrom), parseFloat(amountTo), 0);
        }

        const step = (1 - 0.5) / this.currentWins.length;

        Tweens.removeTweens(this.counter, "all");
        Tweens.alphaTween(this.counter, {
            alphas: [this.counter.alpha, 1],
            tweenDuration: 20,
        });
        Tweens.scaleTween(this.counter, {
            tweenValues: [
                new PIXI.Point(0.5 + step * this.currentCounterStep, 0.5 + step * this.currentCounterStep),
                new PIXI.Point(0.5 + step * (this.currentCounterStep + 1), 0.5 + step * (this.currentCounterStep + 1)),
            ],
            tweenDuration: 20,
            tweenEase: "backInOut",
        });
    }

    protected runCounterStep2(): void {
        PlayList.play("SND_BaseWin" + (this.currentMultiplierIndex + 1));

        if (this.currentMultiplierIndex > 0) {
            Tweens.removeTweens(this.counter, "all");
            Tweens.scaleTween(this.counter, {
                tweenValues: [new PIXI.Point(1, 1), new PIXI.Point(1.2, 1.2), new PIXI.Point(1, 1)],
                tweenDuration: 30,
            });
        }
    }

    protected runCounterStep3(): void {
        PlayList.play("SND_BaseWinAway");

        Tweens.removeTweens(this.counter, "all");
        Tweens.alphaTween(this.counter, {
            alphas: [1, 0],
            tweenDuration: 30,
        });
        Tweens.scaleTween(this.counter, {
            tweenValues: [new PIXI.Point(1, 1), new PIXI.Point(2, 2)],
            tweenDuration: 30,
        });
    }

    protected runCounterOutro(): void {
        PlayList.play("SND_BaseWin" + (this.currentMultiplierIndex + 1));

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            this.counter.start(0, parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()), 0);
        } else {
            ImageTextCounterElement.Round = false;
            this.counter.start(0, this.currentWin, 0);
        }

        Tweens.removeTweens(this.counter, "all");
        Tweens.alphaTween(this.counter, {
            alphas: [1, 0],
            tweenDuration: 20,
            tweenDelay: 20,
        });
        Tweens.scaleTween(this.counter, {
            tweenValues: [new PIXI.Point(1, 1), new PIXI.Point(2, 2)],
            tweenDuration: 20,
            tweenDelay: 20,
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/